import { useMe } from '@/routes/_app/use-me';
import { TermsAcceptanceModal } from './terms-acceptance-modal.tsx';

export const TermsAcceptance = () => {
  const me = useMe();

  const needsTermsAcceptance = !me.acceptedTermsOfService;
  const needsPrivacyAcceptance = !me.acceptedPrivacyPolicy;
  const shouldShowModal = needsTermsAcceptance || needsPrivacyAcceptance;

  if (!shouldShowModal) {
    return null;
  }

  return (
    <TermsAcceptanceModal
      open={shouldShowModal}
      needsTermsAcceptance={needsTermsAcceptance}
      needsPrivacyAcceptance={needsPrivacyAcceptance}
    />
  );
};
